/* SunFit Swatch - kopplar de egna swatcharna till Dawns (dolda) variantväljare.
   Klick på en swatch -> samma radio/select i Dawn markeras och får ett 'change'-event,
   så pris, bild, URL, köpknapp och Kaching uppdateras precis som med GLO.
   Ändrar något annat Dawns väljare (t.ex. AR-provningen) följer swatcharna med. */
(function () {
  function init(root) {
    if (root.__sfsw) return;
    root.__sfsw = true;
    var section = root.getAttribute('data-section');

    function picker() {
      return document.getElementById('variant-radios-' + section) || document.getElementById('variant-selects-' + section);
    }

    function setLegend(option, value) {
      var name = option.querySelector('.sfsw__name-variant');
      if (name) name.lastChild.nodeValue = value;
    }

    /* Mall utan Dawn-väljare: gör som GLO - sätt variant-id i köpformuläret,
       skicka input/change, uppdatera ?variant= och meddela 'variant:change' (Kaching lyssnar). */
    var standalone = root.hasAttribute('data-standalone');
    var variants = [];
    if (standalone) {
      try { variants = JSON.parse(root.querySelector('[data-sfsw-variants]').textContent); } catch (e) {}
    }

    function idInputs() {
      return document.querySelectorAll('#product-form-' + section + ' input[name="id"], #product-form-installment-' + section + ' input[name="id"]');
    }

    function selectedValues() {
      return Array.prototype.map.call(root.querySelectorAll('.sfsw__option'), function (option) {
        var c = option.querySelector('.sfsw__input:checked');
        return c ? c.value : null;
      });
    }

    function pushStandalone() {
      var values = selectedValues();
      var variant = null;
      for (var i = 0; i < variants.length && !variant; i++) {
        var ok = true;
        for (var j = 0; j < values.length; j++) if (variants[i].options[j] !== values[j]) ok = false;
        if (ok) variant = variants[i];
      }
      if (!variant) return;
      Array.prototype.forEach.call(idInputs(), function (input) {
        if (String(input.value) === String(variant.id)) return;
        input.value = variant.id;
        input.dispatchEvent(new Event('input', { bubbles: true }));
        input.dispatchEvent(new Event('change', { bubbles: true }));
      });
      window.history.replaceState({}, '', location.pathname + '?variant=' + variant.id);
      document.dispatchEvent(new CustomEvent('variant:change', { detail: { variant: variant } }));
    }

    function pullStandalone() {
      var input = idInputs()[0];
      if (!input) return;
      var variant = null;
      for (var i = 0; i < variants.length; i++) if (String(variants[i].id) === String(input.value)) variant = variants[i];
      if (!variant) return;
      Array.prototype.forEach.call(root.querySelectorAll('.sfsw__option'), function (option) {
        var value = variant.options[+option.getAttribute('data-index')];
        var inputs = option.querySelectorAll('.sfsw__input');
        for (var k = 0; k < inputs.length; k++) {
          if (inputs[k].value === value) {
            if (!inputs[k].checked) inputs[k].checked = true;
            setLegend(option, value);
          }
        }
      });
    }

    function pushToPicker(index, value) {
      if (standalone) return pushStandalone();
      var p = picker();
      if (!p) return;
      if (p.tagName === 'VARIANT-RADIOS') {
        var fieldset = p.querySelectorAll('fieldset')[index];
        if (!fieldset) return;
        var inputs = fieldset.querySelectorAll('input[type="radio"]');
        for (var i = 0; i < inputs.length; i++) {
          if (inputs[i].value === value) {
            if (!inputs[i].checked) {
              inputs[i].checked = true;
              inputs[i].dispatchEvent(new Event('change', { bubbles: true }));
            }
            return;
          }
        }
      } else {
        var select = p.querySelectorAll('select')[index];
        if (select && select.value !== value) {
          select.value = value;
          select.dispatchEvent(new Event('change', { bubbles: true }));
        }
      }
    }

    function pickerValues() {
      var p = picker();
      if (!p) return null;
      if (p.tagName === 'VARIANT-RADIOS') {
        return Array.prototype.map.call(p.querySelectorAll('fieldset'), function (fs) {
          var c = fs.querySelector('input[type="radio"]:checked');
          return c ? c.value : null;
        });
      }
      return Array.prototype.map.call(p.querySelectorAll('select'), function (s) { return s.value; });
    }

    function pullFromPicker() {
      if (standalone) return pullStandalone();
      var values = pickerValues();
      if (!values) return;
      Array.prototype.forEach.call(root.querySelectorAll('.sfsw__option'), function (option) {
        var value = values[+option.getAttribute('data-index')];
        if (value == null) return;
        var inputs = option.querySelectorAll('.sfsw__input');
        for (var i = 0; i < inputs.length; i++) {
          if (inputs[i].value === value) {
            if (!inputs[i].checked) inputs[i].checked = true;
            setLegend(option, value);
            return;
          }
        }
      });
    }

    root.addEventListener('change', function (e) {
      var input = e.target;
      if (!input.classList || !input.classList.contains('sfsw__input')) return;
      e.stopPropagation();
      var option = input.closest('.sfsw__option');
      setLegend(option, input.value);
      pushToPicker(+option.getAttribute('data-index'), input.value);
    });

    document.addEventListener('change', function (e) {
      if (standalone) {
        if (e.target && e.target.name === 'id' && e.target.closest && e.target.closest('#product-form-' + section)) pullStandalone();
        return;
      }
      var p = picker();
      if (p && p.contains(e.target)) pullFromPicker();
    });

    window.addEventListener('pageshow', pullFromPicker);
    pullFromPicker();
  }

  function boot() {
    Array.prototype.forEach.call(document.querySelectorAll('.sfsw[data-section]'), init);
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', boot);
  else boot();
})();
